import React from "react";
import TerapiasComponent from "../components/TerapiasComponent";
import Seo from "../seo/Seo";
import { seoConfig } from "../seo/seoConfig";

const Terapias = () => {
  return (
    <div>
      <Seo {...seoConfig.terapias} />
      <div className="container">
        <h1 className="texto-titulo my-5 pb-4">TERAPIAS</h1>
        <TerapiasComponent />
      </div>
    </div>
  );
};

export default Terapias;
